const envConfig = {
  SERVER_URL: import.meta.env.VITE_SERVER_URL,
  AZURE_KEY: import.meta.env.VITE_AZURE_KEY,
  AZURE_REGION: import.meta.env.VITE_AZURE_REGION,
  ENABLE_SENTRY: import.meta.env.VITE_ENABLE_SENTRY,
  APP_ENV: import.meta.env.VITE_APP_ENV,
}

export { envConfig }
